"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeviewTmp = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const lab_1 = require("@material-ui/lab");
const lodash_1 = require("lodash");
const uuidv4_1 = __importDefault(require("uuidv4"));
const core_1 = require("@material-ui/core");
const SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
function MinusSquare(props) {
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ fontSize: "inherit", style: { width: 14, height: 14 } }, props),
        react_1.default.createElement("path", { d: "M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" })));
}
function PlusSquare(props) {
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ fontSize: "inherit", style: { width: 14, height: 14 } }, props),
        react_1.default.createElement("path", { d: "M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" })));
}
// function CloseSquare(props: SvgIconProps) {
//     return (
//         <SvgIcon className="close" fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
//             {/* tslint:disable-next-line: max-line-length */}
//             <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
//         </SvgIcon>
//     );
// }
const TreeviewComponent = (props) => {
    const { options: { data }, parentsIcon = undefined, icon = undefined, className = '', id = '', ref, onChange, } = props;
    const [expanded, setExpanded] = react_1.useState([]);
    const [selectedIdList, setSelectedIdList] = react_1.useState([]);
    const [treeData, setTreeData] = react_1.useState([]);
    const setKeyToChildren = react_2.useCallback((children) => {
        const newChildren = [];
        children.forEach(row => {
            row.key = uuidv4_1.default();
            if (row.children && row.children.length > 0) {
                row.children = setKeyToChildren(row.children);
                row.state.selected = row.children.find(f => f.state.selected) != null;
            }
            newChildren.push(row);
        });
        return newChildren;
    }, []);
    const findExpandChildren = react_2.useCallback((children) => {
        const newOpenedItems = [];
        children.forEach(row => {
            var _a;
            if (row.state.opened) {
                newOpenedItems.push((_a = row.id) !== null && _a !== void 0 ? _a : row.key);
            }
            if (row.children && row.children.length > 0) {
                findExpandChildren(row.children).forEach(row2 => {
                    newOpenedItems.push(row2);
                });
            }
        });
        return newOpenedItems;
    }, []);
    const getExpandedList = react_2.useCallback((tree) => {
        const list = [];
        tree.forEach(row => {
            var _a;
            if (row.state.opened) {
                list.push((_a = row.id) !== null && _a !== void 0 ? _a : row.key);
            }
            if (row.children && row.children.length > 0) {
                findExpandChildren(row.children).forEach(row2 => {
                    list.push(row2);
                });
            }
        });
        return list;
    }, [findExpandChildren]);
    const findSelectedChildren = react_2.useCallback((children) => {
        const newSelectedItems = [];
        children.forEach(row => {
            if (row.state.selected && row.id) {
                newSelectedItems.push(row.id);
            }
            if (row.children && row.children.length > 0) {
                findSelectedChildren(row.children).forEach(row2 => {
                    newSelectedItems.push(row2);
                });
            }
        });
        return newSelectedItems;
    }, []);
    const getSelectedList = react_2.useCallback((tree) => {
        const list = [];
        tree.forEach(row => {
            if (row.state.selected && row.id) {
                list.push(row.id);
            }
            if (row.children && row.children.length > 0) {
                findSelectedChildren(row.children).forEach(row2 => {
                    list.push(row2);
                });
            }
        });
        return list;
    }, [findSelectedChildren]);
    react_1.useEffect(() => {
        const newTreeData = [];
        data.forEach(row => {
            row.key = uuidv4_1.default();
            if (row.children && row.children.length > 0) {
                row.children = setKeyToChildren(row.children);
                row.state.selected = row.children.find(f => f.state.selected) != null;
            }
            newTreeData.push(row);
        });
        const expandedList = getExpandedList(newTreeData);
        const selectedList = getSelectedList(newTreeData);
        setTreeData(newTreeData);
        setExpanded(expandedList);
        setSelectedIdList(selectedList);
    }, [data, getExpandedList, getSelectedList, setKeyToChildren]);
    react_1.useEffect(() => {
        onChange && onChange(selectedIdList);
    }, [selectedIdList, onChange]);
    const setSlectionToChildren = (children, item, selected) => {
        const newChildren = [];
        children.forEach(row => {
            if (selected !== undefined) {
                row.state.selected = selected;
                if (row.children && row.children.length > 0) {
                    row.children = setSlectionToChildren(row.children, item, selected);
                }
            }
            else {
                if (row.key && row.key === item.key) {
                    row.state.selected = item.state.selected ? false : true;
                    if (row.children && row.children.length > 0) {
                        row.children = setSlectionToChildren(row.children, item, row.state.selected);
                    }
                }
                else if (row.children && row.children.length > 0) {
                    row.children = setSlectionToChildren(row.children, item);
                }
            }
            if (row.children && row.children.length > 0) {
                row.state.selected = row.children.find(f => f.state.selected) != null;
            }
            newChildren.push(row);
        });
        return newChildren;
    };
    const selectionOnChangeHandler = (item) => {
        const newTreeData = [];
        treeData.forEach(row => {
            const selected = item.state.selected ? false : true;
            if (row.key && row.key === item.key) {
                row.state.selected = selected;
                if (row.children && row.children.length > 0) {
                    row.children = setSlectionToChildren(row.children, item, selected);
                }
            }
            else if (row.children && row.children.length > 0) {
                row.children = setSlectionToChildren(row.children, item);
            }
            if (row.children && row.children.length > 0) {
                row.state.selected = row.children.find(f => f.state.selected) != null;
            }
            newTreeData.push(row);
        });
        const selectedList = getSelectedList(newTreeData);
        setTreeData(newTreeData);
        setSelectedIdList(selectedList);
    };
    const setExpandToChildren = (children, item, opened, applyAllChildren) => {
        const newChildren = [];
        children.forEach(row => {
            if (applyAllChildren) {
                row.state.opened = opened;
                if (row.children && row.children.length > 0) {
                    row.children = setExpandToChildren(row.children, item, opened, true);
                }
            }
            else {
                if (row.key && row.key === item.key) {
                    row.state.opened = opened;
                    if (row.children && row.children.length > 0) {
                        row.children = setExpandToChildren(row.children, item, opened, true);
                    }
                }
                else if (row.children && row.children.length > 0) {
                    row.children = setExpandToChildren(row.children, item, opened);
                }
            }
            newChildren.push(row);
        });
        return newChildren;
    };
    const collapseOrExpandOnChangeHandler = (item, opened) => {
        const newTreeData = [];
        treeData.forEach(row => {
            if (row.key && row.key === item.key) {
                row.state.opened = opened;
                if (row.children && row.children.length > 0) {
                    row.children = setExpandToChildren(row.children, item, opened, true);
                }
            }
            else if (row.children && row.children.length > 0) {
                row.children = setExpandToChildren(row.children, item, opened);
            }
            newTreeData.push(row);
        });
        setTreeData(newTreeData);
        const expandedList = getExpandedList(newTreeData);
        setExpanded(expandedList);
    };
    const getTreeItemsFromData = (treeItems) => {
        return treeItems.map((treeItemData) => {
            var _a;
            return (react_1.default.createElement(lab_1.TreeItem, { className: `oneframe-tree-item`, key: treeItemData.key, nodeId: (_a = treeItemData.id) !== null && _a !== void 0 ? _a : treeItemData.key, label: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.Checkbox, { checked: treeItemData.state.selected, disabled: treeItemData.state.disabled, onChange: e => selectionOnChangeHandler(treeItemData) }),
                    react_1.default.createElement("span", { onClick: e => treeItemData.state.disabled ? () => void (0) : selectionOnChangeHandler(treeItemData) }, treeItemData.text)), 
                // endIcon={<CloseSquare />}
                collapseIcon: react_1.default.createElement(MinusSquare, { onClick: e => collapseOrExpandOnChangeHandler(treeItemData, false) }), expandIcon: react_1.default.createElement(PlusSquare, { onClick: e => collapseOrExpandOnChangeHandler(treeItemData, true) }), icon: icon }, treeItemData.children && treeItemData.children.length > 0
                ? getTreeItemsFromData(treeItemData.children)
                : ''));
        });
    };
    return (react_1.default.createElement(lab_1.TreeView, { id: id, ref: ref, expanded: expanded, defaultParentIcon: parentsIcon, className: `oneframe-tree-view ${className}`, multiSelect: true }, getTreeItemsFromData(treeData)));
};
TreeviewComponent.propTypes = {
    options: prop_types_1.default.shape({
        data: prop_types_1.default.arrayOf(prop_types_1.default.object).isRequired,
        onClick: prop_types_1.default.func,
    }),
    parentsIcon: prop_types_1.default.node,
    collapseIcon: prop_types_1.default.node,
    expandIcon: prop_types_1.default.node,
    deepItemIcon: prop_types_1.default.node,
    icon: prop_types_1.default.node,
    className: prop_types_1.default.string,
    iconPosition: prop_types_1.default.oneOf(['left', 'right', undefined]),
    expandedDataIds: prop_types_1.default.arrayOf(prop_types_1.default.string),
    defaultExpandedDataIds: prop_types_1.default.arrayOf(prop_types_1.default.string),
    onToggle: prop_types_1.default.func,
    id: prop_types_1.default.string,
    ref: prop_types_1.default.any,
    onChange: prop_types_1.default.func,
};
exports.TreeviewTmp = TreeviewComponent;
exports.default = react_1.default.memo(TreeviewComponent, (p, n) => lodash_1.isEqual(p, n));
